import { toast } from './appToast';

/** estado API: 0 = vigente/habilitado, 2 = deshabilitado */
export const isEstadoVigente = (estado) => Number(estado) === 0;

export const toastEstadoCambio = (mensaje, nuevoEstado) => {
    const texto = mensaje || 'Estado actualizado';
    if (isEstadoVigente(nuevoEstado)) {
        toast.success(texto);
    } else {
        toast.error(texto);
    }
};
